/* global globalThis */
import React, {useState, useEffect} from 'react';
import {ActivityIndicator, View} from 'react-native';
import {Divider, Dialog as PaperDialog, Portal} from 'react-native-paper';
import isString from 'lodash/isString';

import sy from '~/styles';

import {Text, ActionButton} from '~/components/controls';
import PropTypes from 'prop-types';

const Dialog = ({
  style,
  visible,
  dismissable,
  onDismiss,
  title,
  titleIcon,
  titleStyle,
  children,
  initialValue: _initialValue,
  buttons,
  options = {
    hideDividers: false,
    showFooterLoading: false,
    noPaddingContent: false,
  },
}) => {
  const [initialValue, setInitialValue] = useState(_initialValue);

  useEffect(() => {
    // Only update the initial value if the dialog is hidden.
    // This prevents updates to the initial value when the dialog is shown, which is not what we want.
    if (!visible) {
      setInitialValue(_initialValue);
    }
  }, [visible, _initialValue]);

  let footer = (
    <ActionButton onPress={() => onDismiss({initialValue})}>OK</ActionButton>
  );
  if (buttons) {
    footer = buttons.map((button) => (
      <ActionButton
        key={button.text}
        onPress={() =>
          globalThis.requestAnimationFrame(() => button.onPress({initialValue}))
        }
        disabled={button.disabled}>
        {button.text}
      </ActionButton>
    ));
  }

  return (
    <Portal>
      <PaperDialog
        style={style}
        visible={visible}
        dismissable={onDismiss ? dismissable : false}
        onDismiss={() => onDismiss({initialValue})}>
        {title && (
          <>
            <View
              style={[
                sy['flex-row'],
                sy['justify-between'],
                sy['items-center'],
                {marginLeft: 24, marginRight: 24, minHeight: 64},
                titleStyle,
              ]}>
              {isString(title) ? (
                <Text style={[sy.largePlus]}>{title}</Text>
              ) : (
                title
              )}
              {titleIcon}
            </View>
            {!options.hideDividers && <Divider style={sy['bg-gray88']} />}
          </>
        )}
        <PaperDialog.Content
          style={[
            {paddingBottom: 0},
            options.noPaddingContent ? {paddingHorizontal: 0} : null,
          ]}>
          {children}
        </PaperDialog.Content>
        {!options.hideDividers && <Divider style={sy['bg-gray88']} />}
        <PaperDialog.Actions style={sy['gap-2']}>
          {options.showFooterLoading ? (
            <ActivityIndicator size="large" color="#231fda" />
          ) : (
            footer
          )}
        </PaperDialog.Actions>
      </PaperDialog>
    </Portal>
  );
};
Dialog.propTypes = {
  style: PropTypes.any,
  visible: PropTypes.any,
  dismissable: PropTypes.any,
  onDismiss: PropTypes.any,
  title: PropTypes.any,
  titleIcon: PropTypes.any,
  titleStyle: PropTypes.any,
  children: PropTypes.any,
  initialValue: PropTypes.any,
  buttons: PropTypes.any,
  options: PropTypes.any,
};

export default Dialog;
